import DataAPISerializer from 'rise-ui/serializers/apis/rise-api/data.js';

import { keyForAttribute } from 'rise-ui/utils/serializer/map.js';

@keyForAttribute({
  title:       'modelRunName',
  description: 'modelRunDescription',
})
export default class ModelRunSerializer extends DataAPISerializer {}
